var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRotateLeft = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 29,
    rx: 3.5,
    stroke: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.521,
    y: 2.559,
    width: 22.959,
    height: 23.346,
    rx: 1.75,
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.742 19.476-1.272-1.524a4.436 4.436 0 0 1-1.08.132 4.34 4.34 0 0 1-2.16-.552 4.134 4.134 0 0 1-1.56-1.524c-.384-.656-.576-1.396-.576-2.22 0-.816.192-1.548.576-2.196a4.108 4.108 0 0 1 1.56-1.536 4.34 4.34 0 0 1 2.16-.552c.792 0 1.512.184 2.16.552.656.368 1.172.88 1.548 1.536.384.648.576 1.38.576 2.196 0 .744-.16 1.424-.48 2.04a4.06 4.06 0 0 1-1.284 1.488l1.92 2.16h-2.088Zm-4.92-5.688c0 .56.108 1.052.324 1.476.216.424.516.752.9.984.392.224.84.336 1.344.336.504 0 .948-.112 1.332-.336.384-.232.684-.56.9-.984.216-.424.324-.916.324-1.476 0-.56-.108-1.048-.324-1.464a2.305 2.305 0 0 0-.9-.972c-.384-.224-.828-.336-1.332-.336a2.66 2.66 0 0 0-1.344.336 2.305 2.305 0 0 0-.9.972c-.216.416-.324.904-.324 1.464Z",
    fill: "#fff"
  })));
};
export { SvgRotateLeft as ReactComponent };